export default __webpack_public_path__ + "static/media/warning.9cb33951.svg";